import { useFlowType } from "@lending/hooks/useFlowType";
import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useProductType } from "@lending/hooks/useProductType";
import { useApi } from "@lending/lib/api";
import { getMembershipShareEndpoint } from "@lending/pages/Common/MembershipShare/hooks/getMembershipShareEndpoint";

function useGetMembershipsQuery() {
  const $api = useApi();
  const applicationUuid = useLendingApplicationID();
  const productType = useProductType();
  const flowType = useFlowType();
  const endpoint = getMembershipShareEndpoint(productType, "memberships");

  return $api.useQuery(
    "get",
    endpoint,
    {
      params: {
        path: {
          uuid: applicationUuid,
        },
      },
    },
    {
      enabled: Boolean(applicationUuid && flowType),
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
}

export { useGetMembershipsQuery };
